import { render, staticRenderFns } from "./DataSourcesConfigurationPanel.vue?vue&type=template&id=25117603&"
import script from "./DataSourcesConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./DataSourcesConfigurationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports